import type React from 'react';

import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';

import type { SupporterComment } from '../../shared/types';

export const DeleteSuccessMessage: React.FC<{ comment: SupporterComment }> = ({ comment }) => {
	return (
		<InlineMessage variant="success" title="Success" mb={8}>
			{comment.__typename === 'PetitionVideoComment' ? 'Video' : 'Comment'} successfully removed.
		</InlineMessage>
	);
};

export const DeleteErrorMessage: React.FC = () => {
	return (
		<InlineMessage variant="warning" title="Delete failed" mb={8}>
			Something went wrong while deleting.
		</InlineMessage>
	);
};

export const DeleteMessage: React.FC<{
	message: 'success' | 'error' | undefined;
	comment: SupporterComment;
}> = ({ message, comment }) => {
	if (message === 'success') return <DeleteSuccessMessage comment={comment} />;
	if (message === 'error') return <DeleteErrorMessage />;
	return null;
};
